// extracted by mini-css-extract-plugin
export default {"customerCard":"customerCard_customerCard__q-v0N","customerName":"customerCard_customerName__+l0MM","customerInfo":"customerCard_customerInfo__e0hWP"};